module.exports = __webpack_public_path__ + "static/media/How-Is-My-Cars-Value-Affected-By-Damaged-Catalyst.8b213e1f.jpg";